import { AfterViewInit, Component, OnInit, Renderer2 } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { RoleBasedAdminService } from "app/modules/role-based-admin/role-based-admin.service";
import { GlobalService } from "app/services/global.service";
import { PageService } from "app/services/page-service";
declare var require: any;
const modules = require("app/modules.json");

@Component({
  selector: "app-admin-layout",
  templateUrl: "./admin-layout.component.html",
  styleUrls: ["./admin-layout.component.scss"],
})
export class AdminLayoutComponent implements OnInit, AfterViewInit {
  userDetails: any;
  modulesData = modules;
  permissionData: any;
  roleData: any;
  customerModuleAccess = [];
  adminUser: any;

  defaultAccountUser: any;
  accountRoleId = "";

  constructor(
    public service: PageService,
    public renderer: Renderer2,
    public modalService: NgbModal,
    public router: Router,
    public global: GlobalService,
    public roleService: RoleBasedAdminService
  ) {}

  ngOnInit() {
    this.defaultAccountUser = JSON.parse(localStorage.getItem("userDetails"));
    // const Data = this.defaultAccountUser["record"];
    // this.accountRoleId = Data.accountRole;
    // localStorage.setItem("accountRole", this.accountRoleId);
    // if (!(this.accountRoleId === "ADMIN" || this.accountRoleId === "SADMIN")) {
    //   console.log("Account Role ID:", this.accountRoleId);
    //   // this.getAccessRole();
    // } else {
    //   localStorage.removeItem("permissionData");
    // }
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    // console.log("USer");
    if (!this.userDetails) {
      // ////this.global.failureErrorModal({ status: 0 });
      this.router.navigate(["/login"]);
    }
  }
  ngAfterViewInit() {
    // let loader = this.renderer.selectRootElement('#loader');
    // loader.style.display = "none";
  }

  getAccessRole() {
    const data = {
      roleID: this.accountRoleId,
    };
    // this.roleService.getAccessRole(data).then((response) => {
    //   this.permissionData = this.transformPermissionData(
    //     response["data"]["permissions"]
    //   );
    //   this.roleData = response["data"]["role"];
    //   console.log(this.roleData);
    //   if (this.roleData && this.roleData["city"]) {
    //     localStorage.setItem(
    //       "selectedCityData",
    //       JSON.stringify(this.roleData["city"])
    //     );
    //   }
    //   if (this.permissionData) {
    //     localStorage.setItem(
    //       "permissionData",
    //       JSON.stringify(this.permissionData)
    //     );
    //   }
    // });
  }

  transformPermissionData(permissionsArray: any[]): any {
    // console.log(permissionsArray)
    const transformedData = {};

    permissionsArray.forEach((module) => {
      transformedData[module.moduleName] = {};

      module.permissions.forEach((permission) => {
        transformedData[module.moduleName][permission.name] =
          permission.permission !== 0;
      });
    });

    return transformedData;
  }
}
